import React from "react";
import ReactDom from "react-dom";
import { Col, FormGroup } from "reactstrap";
import { Button as Btn } from "react-md";
import { getNotifications, deleteNotification } from "../requests/req_notif";
import { notifica } from "../requests/utils";
import Moment from "react-moment";
import "moment/locale/es";
import "moment-timezone";
import Swal from "sweetalert2";
import { DeleteSVGIcon } from "@react-md/material-icons";

export default class Notificaciones extends React.Component {
  constructor(props) {
    super(props);
    this.elimina = this.elimina.bind(this);
    this.claseNotif = this.claseNotif.bind(this);
    this.ActionResult = this.ActionResult.bind(this);
    this.obtieneDatos = this.obtieneDatos.bind(this);
    this.generaNotifs = this.generaNotifs.bind(this);
  }

  //Función que obtiene la información de las notificaciones
  componentDidMount() {
    getNotifications((n) => this.obtieneDatos(n));
  }

  obtieneDatos(dats) {
    var dv = document.getElementById("dv_notifs");

    if (dats.code === 0) {
      if (dats.data.length > 0) {
        ReactDom.render(
          <FormGroup className="ARC_Notif" row>
            {this.generaNotifs(dats.data)}
          </FormGroup>,
          dv
        );
      } else {
        notifica("info", "No tienes notificaciones pendientes.", "Muy bien!");
      }
    } else {
      notifica("warning", dats.message, "Alerta");
    }
  }

  //DV_Fluid
  generaNotifs(datos) {
    return datos.map((a, index) => {
      var tpn = this.claseNotif(a.idActividad);

      const style = {
        borderRadius: 20,
      };

      return (
        <Col
          sm={3}
          md={3}
          lg={3}
          key={index}
          className="dv_Ntf"
          id={"Bx_" + a.idNotificaCandidato}
        >
          <div style={style} className={"dv_Ntf_cnt Ntf_" + tpn}>
            <label className="lbl_bg">{a.Actividad}</label>
            <label className="lbl_sm">{a.Descripcion}</label>
            <br />
            <div className="DV_Fluid">
              {/* <div className='dv_Ntf_bg'><label className='lbl_sm'>{a.Fecha}</label></div> */}

              <div className="dv_Ntf_bg">
                <label className="lbl_sm">
                  {<Moment format="D [de] MMMM [del] YYYY">{a.Fecha}</Moment>}
                </label>
              </div>
              <div className="dv_Ntf_sm">
                <Btn
                  floating
                  primary
                  icon={<DeleteSVGIcon />}
                  className="btn_trns_sml"
                  idnotifica={a.idNotificaCandidato}
                  onClick={(e) => this.elimina(e)}
                >
                  <DeleteSVGIcon />
                </Btn>
              </div>
            </div>
          </div>
        </Col>
      );
    });
  }

  //define un estilo dependiendo del tipo de actividad
  claseNotif(id) {
    switch (id) {
      case 1:
        return "base";
      case 2:
        return "info";
      case 3:
        return "success";
      default:
        return "gray";
    }
  }

  //función que elimina la notificación
  elimina(e) {
    var elm = e.target,
      btn = elm.type === "button" ? elm : elm.parentElement,
      idN = btn.getAttribute("idnotifica"),
      Bx = document.getElementById("Bx_" + idN),
      lbl = document.getElementById("lbl_util");

    Swal.fire({
      title: "¿Deseas eliminar la notificacion?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
    }).then((result) => {
      if (result.value) {
        lbl.innerText = idN;
        Bx.classList.add("Hide_All");
        deleteNotification((d) => this.ActionResult(d));
      }
    });
  }

  ActionResult(res) {
    if (res.code === 0) {
      notifica("info", "Se elimino la notificación.", "Info");
    } else {
      notifica("danger", res.message, "Error");
    }
  }

  render() {
    return <div className="ARC_Notificaciones" id="dv_notifs"></div>;
  }
}
